export const enameledPan = {
  recipes: [
    {
      id: 'Chicken Divan',
      link: 'https://pamperedchef.widen.net/view/thumbnail/6gcxgj2sc8/post-recipe-chicken-divan-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/6gcxgj2sc8/jpeg/post-recipe-chicken-divan-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-chicken-divan-steps.jpg',
      },
    },
  ],
};
